/**
 * Return a query string with replaced values
 *
 * if `subResource` is provided the query will look like:
 *
 * `subResource.field.Contains(searchValue)`
 *
 * @param string searchValue
 * @param string subResource
 * @returns string query
 */
export const getNameAndEmailFilter = (searchValue, subResource, field) => {
	let query =
		'($RESOURCE.lastName.Contains("$QUERY") || $RESOURCE.firstName.Contains("$QUERY") || $RESOURCE.firstName + " " + $RESOURCE.lastName = "$QUERY" || $RESOURCE.$FIELD.Contains("$QUERY"))';

	const fieldReplace = field || 'email';
	query = query.replace(/(\$FIELD)/g, fieldReplace);

	subResource = subResource ? `${subResource}.` : '';

	query = query.replace(/(\$RESOURCE.)/g, subResource);
	query = query.replace(/(\$QUERY)/g, searchValue);

	return query;
};
